import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import ModalOptions from '@jimmyboys/liita-ui/dist/components/ModalOptions'
import Avatar from '@jimmyboys/liita-ui/dist/components/Avatar'
import Skeleton from '@jimmyboys/liita-ui/dist/components/Skeleton'

import styles from './CommentCard.module.sass'
import FuseHighlight from 'components/FuseHighlight/FuseHighlight'
import CommentCardActions from './CommentCardActions'

const OpenFileModal = ({ title, options, openFile }) => {
	return (
		<ModalOptions
			title={title}
			options={options}
			centerArrow
			fixedHeight='auto'
			alwaysAbove
			selectable={false}
			onSelect={(e) => {
				openFile && openFile(e)
				return true
			}}
		>
			<button className={styles['attachments']}>
				<Icon width='20px' height='20px' name='attachment' />
			</button>
		</ModalOptions>
	)
}

const TitleDateInfo = ({ data, labels }) => {
	return (
		<span>
			{data.$detailLevel === 'summary' ? (
				<h5 className={styles['user']}>
					{data.title || labels.commentTitle}
				</h5>
			) : (
				<h5>#{data.id}</h5>
			)}
			<small className={`${styles['date']} ${styles['entity']}`}>
				<Icon
					className={styles['text-icon']}
					name='calendar'
					width='14px'
					height='14px'
				/>
				{data.date?.dateTimeFormat}
			</small>
		</span>
	)
}

const DoctorInfo = ({ data }) => {
	return (
		<span className={styles['doctor-info']}>
			<h5 className={styles['user']}>
				<FuseHighlight
					matchedWords={
						data.$textHighlight?.matchedIndexes?.['author.name']
					}
					text={data?.author?.name}
				/>
			</h5>
			<small className={styles['entity']}>
				{data?.providerEstablishment?.name}
			</small>
		</span>
	)
}

const AvatarContainer = ({ data }) => {
	return (
		<span className={styles['avatar-container']}>
			<Avatar rounded className={styles['avatar']} user={data?.author} />
		</span>
	)
}

const renderFlippedHeader = ({ data, labels, openFile }) => (
	<div
		className={`${styles['header-table']} ${styles['trust-header']} ${
			styles['small']
		} ${data?.$detailLevel !== 'summary' ? styles['detail-header'] : ''}`}
	>
		<span className={`${styles['cell']} ${styles['extra-info']}`}>
			<CommentCardActions data={data} flipped />
			{data.hasFiles && (
				<OpenFileModal
					title={labels.documents}
					options={data.filesOptions}
					openFile={openFile}
				/>
			)}

			<TitleDateInfo data={data} labels={labels} />
		</span>
		<span className={styles['cell']}>
			<span className={styles['user-container']}>
				<DoctorInfo data={data} />
				<AvatarContainer data={data} />
			</span>
		</span>
	</div>
)

const renderRegular = ({ data, labels, openFile }) => (
	<div
		className={`${styles['header-table']} ${styles['default-header']} ${
			styles['small']
		} ${data?.$detailLevel !== 'summary' ? styles['detail-header'] : ''}`}
	>
		<span className={`${styles['cell']}`}>
			<span className={styles['user-container']}>
				<AvatarContainer data={data} />
				<DoctorInfo data={data} />
			</span>
		</span>
		<span className={`${styles['cell']} ${styles['extra-info']}`}>
			<TitleDateInfo data={data} labels={labels} />
			{data.hasFiles && (
				<OpenFileModal
					title={labels.documents}
					options={data.filesOptions}
					openFile={openFile}
				/>
			)}
			<CommentCardActions data={data} />
		</span>
	</div>
)

const CommentCardHeader = ({ flipped, ...props }) =>
	flipped ? renderFlippedHeader(props) : renderRegular(props)

export default CommentCardHeader

export const renderCommentHeaderSkeleton = () => (
	<div className={`${styles['header-table']} ${styles['medium']}`}>
		<span className={`${styles['cell']}`}>
			<span className={styles['user-container']}>
				<span className={styles['avatar-container']}>
					<Skeleton
						className={`${styles['skeleton']} ${styles['circle']}`}
					/>
				</span>
				<span className={styles['doctor-info-skeleton']}>
					<h5 className={styles['user-skeleton']}>
						<Skeleton
							className={`${styles['skeleton']} ${styles['medium']}`}
						/>
					</h5>
					<small className={styles['entity']}>
						<Skeleton
							className={`${styles['skeleton']} ${styles['smaller']}`}
						/>
					</small>
				</span>
			</span>
		</span>
	</div>
)
